import { render, staticRenderFns } from "./EditingDFInputNumber.vue?vue&type=template&id=478f88b4&"
import script from "./EditingDFInputNumber.vue?vue&type=script&lang=js&"
export * from "./EditingDFInputNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports